import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {ModalModule} from 'ngx-bootstrap';
import {ConfirmationModalComponent} from './confirmation-modal.component';

@NgModule({
  declarations: [
    ConfirmationModalComponent
  ],
  exports: [
    ConfirmationModalComponent
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    ModalModule.forRoot()
  ],
  providers: []
})
export class ConfirmationModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/confirmation/confirmation.module.ts